import { sanitizeFetchType } from 'react-admin'
import { PassageDto } from '../../dto/device/passages/passage.dto'
import { ResourceName } from '../../ResourceName'
import {
  ToggleButtonAction,
  ToggleButtonState,
  ToggleType,
} from './passage-set-boolean-status-button'
import { DateTime } from '../../common/date-time'

type Mutation = {
  type: string
  resource: string
  // eslint-disable-next-line @typescript-eslint/ban-types
  payload?: object
}

const turnOffMutation = (
  { id }: PassageDto,
  auditNote?: string,
  recurringJobName?: string,
  cronExpression?: string,
  scheduledAt?: DateTime,
): Mutation => ({
  type: sanitizeFetchType('setPPOZState'),
  resource: ResourceName.PASSAGES,
  payload: {
    passageId: id,
    ppozState: false,
    auditComment: auditNote,
    recurringJobName,
    cronExpression,
    scheduledAt,
  },
})

const turnOnMutation = (
  { id }: PassageDto,
  auditNote?: string,
  recurringJobName?: string,
  cronExpression?: string,
  scheduledAt?: DateTime,
): Mutation => ({
  type: sanitizeFetchType('setPPOZState'),
  resource: ResourceName.PASSAGES,
  payload: {
    passageId: id,
    ppozState: true,
    auditComment: auditNote,
    recurringJobName,
    cronExpression,
    scheduledAt,
  },
})

type State = {
  mutateQuery?: (
    passage: PassageDto,
    auditNote?: string,
    recurringJobName?: string,
    cronExpression?: string,
    scheduledAt?: DateTime,
  ) => Mutation
} & ToggleButtonState

export const passageSetPPOZButtonInitialState = {
  type: ToggleType.OFF,
  text: 'resources.passages.actions.setPPOZState.turnOn',
}

export const passageSetPPOZButtonReducer = (
  state: State,
  { type }: ToggleButtonAction,
): State => {
  switch (type) {
    case ToggleType.OFF: {
      return {
        type,
        text: 'resources.passages.actions.setPPOZState.turnOn',
        mutateQuery: turnOnMutation,
      }
    }
    case ToggleType.ON: {
      return {
        type,
        text: 'resources.passages.actions.setPPOZState.turnOff',
        mutateQuery: turnOffMutation,
      }
    }
    default:
      throw new Error()
  }
}
